import { useEffect, useMemo, useState } from 'react';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';
import { AuthContext } from './AuthProvider';

import './pages/common.scss';

// ----------------------------------------------------------------------

export default function App() {
  const [userData, setUserData] = useState({});
  const authContext = useMemo(() => ({
    userData,
    setUserData,
  }));

  return (
    <AuthContext.Provider value={authContext}>
      <ThemeProvider>
        <ScrollToTop />
        <BaseOptionChartStyle />
        <Router />
      </ThemeProvider>
    </AuthContext.Provider>
  );
}
